import HighlightedMedia from "./HighlightedMedia";

export default HighlightedMedia;
